<template>
  <customers-page
    ref="customersPage"
    :export-loading="exportLoading"
    @export-customers="getCsvReport"
    @get-customers="fetchData"
  />
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import CustomersPage from './CustomersPage';
import { downloadBlob } from '@/utils/download';
import { getAndSyncQueryParams } from '@/utils/queryParams';
import { showToast } from '@inscribe/signal';

export default {
  components: {
    CustomersPage,
  },
  data() {
    return {
      queryParams: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      exportLoading: false,
    };
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.queryParams = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
    queryParams: {
      handler: 'fetchData',
      immediate: true,
    },
  },
  methods: {
    ...mapActions([
      'fetchAndCacheCustomers',
      'getCustomers',
      'getAllCustomersExportCsvReport',
    ]),
    getCsvReport() {
      this.exportLoading = true;
      this.getAllCustomersExportCsvReport(this.queryParams)
        .then((response) => {
          downloadBlob(
            response.data,
            `Inscribe Customer Export ${moment().format('YYYY-MM-DD')}.csv`,
            'text/csv',
          );
          this.exportLoading = false;
        })
        .catch((error) => {
          showToast({
            isError: true,
            text: error?.response?.data?.message || 'Error exporting CSV',
          });
          this.exportLoading = false;
        });
    },
    async fetchData() {
      try {
        await this.fetchAndCacheCustomers(this.queryParams);
      } catch (e) {
        console.warn(e);
      }

      // DEPRECATED - leaving in for backwards compatibility
      // Some parts of the app still use the legacy CustomersStore values and
      // those need fresh data.
      this.getCustomers(this.queryParams).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.export_csv_button {
  margin-left: auto;
  cursor: pointer;
}
</style>
